/**
 * Default state for the public calendar bootstrap module.
 *
 * @return {Object}
 */
export default function state() {
	return {
		bootstrapped: false,
		calendars: [],
		error: false,
		loading: false,
		officeHoursStatus: null,
		officeNumber: null,
		partnerName: null,
		shortId: null,
		timezone: null,
	}
}
